<template>
  <div>
    <form data-vv-scope="api">
      <vx-input-group class="mb-base">
      <label class="vs-input--label">Username</label>
        <vs-input
          data-vv-validate-on="blur"
          v-validate="'required'"
          name="portal_username"
          v-model="portal.username"
          placeholder="Username"
        />
        <span
        class="text-danger text-sm"
        v-show="errors.has('api.portal_username')"
      >{{ errors.first('api.portal_username') }}</span>
        <template slot="append">
          <div class="append-text bg-primary custom_span">
            <span>@venue_{{portal.venue_id}}</span>
          </div>
        </template>
      </vx-input-group>

      <vx-input-group class="mb-base">
        <label class="vs-input--label">Password</label>
        <vs-input
          data-vv-validate-on="blur"
          v-validate="'required'"
          name="portal_password"
          v-model="portal.password"
          placeholder="Password"
        />
        <span
        class="text-danger text-sm"
        v-show="errors.has('api.portal_password')"
      >{{ errors.first('api.portal_password') }}</span>
      </vx-input-group>

      <vx-input-group class="mb-base">
      <label class="vs-input--label">Capabilities</label>
        <vs-input
          data-vv-validate-on="blur"
          v-validate="{ regex:/^(?!,)(,?[0-9]+)+$/ }"
          name="capabilities"
          type="text"
          v-model="portal.capabilities"
          placeholder="22,23"
        />
      <span
        class="text-danger text-sm"
        v-show="errors.has('api.capabilities')"
      >{{ errors.first('api.capabilities') }}</span>
      </vx-input-group>
      <label class="vs-input--label">Customer ID</label>
      <vx-input-group class="mb-base">
        <vs-input
          data-vv-validate-on="blur"
          name="portal_customer_id"
          type="text"
          v-model="portal.customer_id"
          placeholder="CUST7896"
        />
      </vx-input-group>

      <label class="vs-input--label">Permissions</label>
      <vx-input-group class="mb-base">
        <ul class="demo-alignment" v-if="portal">
          <li v-for="(permission, index) in permissions" :key="index">
            <vs-checkbox :vs-value="permission" v-model="selected">{{ permission.label }}</vs-checkbox>
          </li>
        </ul>
      </vx-input-group>

      <div class="vx-row">
        <div class="vx-col mr-auto">
          <vs-button @click.prevent="add()">Save</vs-button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { _savePortal, _updatePortal } from "@/services/Venue";

import { Validator } from "vee-validate";
const dict = {
  custom: {
    capabilities: {
      regex: "Capabilities must be comma seperated integers",
    },
  },
};
// register custom messages
Validator.localize("en", dict);

Validator.extend("portal_capabilities", {
  getMessage: (field) => "The " + field + " value is not a valid name.",
  validate: (value) => value.test(/^(?!,)(,?[0-9]+)+$/),
});

export default {
  watch: {
    "$store.state.portalModule.permissions"(val) {
      this.selected = [];
      val.filter((v) => {
        var p = this.permissions.findIndex((x) => x.value === v.value);
        this.selected.push(this.permissions[p]);
      });
    },
  },
  beforeDestroy() {
    this.selected = [];
  },
  mounted() {
    console.log(this.portal);
  },
  computed: {
    portal: {
      get() {
        return this.$store.state.portalModule;
      },
    },
  },
  data: () => ({
    selected: [],
    permissions: [
      {
        label: "Create Booking",
        value: "create_booking",
      },
      {
        label: "Find Booking",
        value: "find_booking",
      },
      {
        label: "Create Booking Quote",
        value: "create_quote",
      },
      {
        label: "Locate a Vehicle",
        value: "locate_vehicle",
      },
    ],
  }),

  methods: {
    add() {
      this.$validator.validateAll("api").then((result) => {
        if (result) {
          this.$vs.loading();
          if (this.portal.id) this.doUpdate();
          else this.doSave();
        }
      });
    },
    doSave() {
      this.portal.permissions = this.selected;
      _savePortal(this.portal.venue_id, this.portal)
        .then(
          (response) => {
            this.handleSuccess(
              response.data.responseTitle,
              response.data.responseMessage
            );
            this.$emit("addParentPortal", response);
          },
          (error) => {
            this.handleError(error);
          }
        )
        .catch((err) => {
          this.handleCatch(err);
        })
        .finally(() => this.$vs.loading.close());
    },

    doUpdate() {
      this.$vs.loading();
      let venue_id = this.portal.venue_id;
      let portal_id = this.portal.id;
      this.portal.permissions = this.selected;

      _updatePortal(venue_id, portal_id, this.portal)
        .then(
          (response) => {
            this.handleSuccess(
              response.data.responseTitle,
              response.data.responseMessage
            );
            this.$emit("addParentPortal", response, "edit");
          },
          (error) => {
            this.handleError(error);
          }
        )
        .catch((error) => {
          this.handleCatch(error);
        })
        .finally(() => this.$vs.loading.close());
    },
    handleSuccess(title, msg) {
      this.$vs.notify({
        title: title,
        text: msg,
        iconPack: "feather",
        icon: "icon-check-circle",
        color: "success",
      });
      this.errors.clear();
    },

    handleError(error) {
      if (error.response.status == 422) {
        this.errors.add({
          scope: "api",
          field: "portal_username",
          msg: error.response.data["errors"].portal_username,
        });
      } else {
        this.$vs.notify({
          title: error.response.data.responseTitle,
          text: error.response.data.responseMessage,
          iconPack: "feather",
          icon: "icon-cross-circle",
          color: "danger",
        });
      }
    },
    handleCatch(error) {
      this.$vs.notify({
        text: error.message,
        iconPack: "feather",
        icon: "icon-cross-circle",
        color: "danger",
      });
    },
  },
};
</script>
<style scoped>
.custom_span{
  margin-top: 20%;
}
</style>
